import React from "react";
import { useRootStore } from "../../../../store/contexts";
import { ShowMultiLine } from "../../../common/controls";
import {
  useSnapshotExtension,
  useSnapshotExtensionTop,
} from "../../../common/controls";
import { FormControl } from "@mui/material";

type EditionDocumentTypeViewProps = {
  snapshotData: any;
  // Propagated from the top-level snapshot view so nested tables can resolve
  // the snapshot-scoped file-download endpoint (/<snapshotEntityName>.data/
  // <snapshotRecordId>/<fileUuid>). Both are optional at the type level but
  // required at runtime for the download / view affordances to work.
  snapshotEntityName?: string;
  snapshotRecordId?: string;
};

export const EditionDocumentTypeView: React.FC<
  EditionDocumentTypeViewProps
> = ({ snapshotData }) => {
  const { langStore } = useRootStore();
  const renderExtensionTop = useSnapshotExtensionTop("EditionDocumentType");
  const renderExtension = useSnapshotExtension("EditionDocumentType");

  return (
    <>
      {renderExtensionTop ? renderExtensionTop(snapshotData) : null}
      <FormControl fullWidth>
        <ShowMultiLine
          label={langStore.EditionDocumentTypeNameLabel}
          value={String(snapshotData?.name ?? "")}
        />
      </FormControl>
      {renderExtension ? renderExtension(snapshotData) : null}
    </>
  );
};
